<button class="trigger" mat-raised-button [matMenuTriggerFor]="menu" #trigger>
  {{ triggerContent }}
  <span class="trigger-counter">{{ count$ | async }}</span>
</button>

<mat-menu class="filter-menu" #menu="matMenu">
  <div class="content-wrapper" (click)="stopClick($event)">
    <ng-content></ng-content>

    <div *ngIf="showActions" class="filter-buttons" (click)="stopClick($event)">
      <button mat-raised-button (click)="clearClick()" i18n>Отмена</button>
      <button mat-raised-button color="primary" (click)="applyClick()" i18n>Применить</button>
    </div>
  </div>
</mat-menu>
